import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { BD } from "@/constants/testIds";
import BridgeDatumLogo from "@/components/shared/BridgeDatumLogo";
import { Mail, MapPin, Phone, ArrowUpRight } from "lucide-react";

const BDFooter = () => {
  const { t } = useI18n();
  const links = [
    ["/about", "nav.about"],
    ["/solutions", "nav.solutions"],
    ["/advisory", "nav.advisory"],
    ["/intelligence", "nav.intelligence"],
    ["/sustainability", "nav.sustainability"],
    ["/sectors", "nav.sectors"],
    ["/insights", "nav.insights"],
    ["/contact", "nav.contact"],
  ];
  return (
    <footer data-testid={BD.footer} className="bg-[#0A192F] text-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <BridgeDatumLogo variant="white" />
          <p className="text-white/70 text-base leading-relaxed max-w-md font-body mt-6">
            {t("footer.tagline")}.
            <br />
            {t("footer.desc")}
          </p>
          <div className="mt-8 text-[11px] tracking-[0.32em] uppercase text-[#D4AF37] font-bold">
            {t("footer.label")}
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="overline text-[#D4AF37] mb-4">{t("footer.navigate")}</div>
          <ul className="space-y-2.5 text-sm">
            {links.map(([h, k]) => (
              <li key={h}>
                <Link to={h} className="text-white/70 hover:text-[#D4AF37] transition-colors link-underline">
                  {t(k)}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="overline text-[#D4AF37] mb-4">{t("footer.contact")}</div>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-0.5 text-[#D4AF37]" />
              <span>{t("footer.address")}</span>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="mt-0.5 text-[#D4AF37]" />
              <a href="mailto:contact@bridgedatum.com" className="hover:text-[#D4AF37]">contact@bridgedatum.com</a>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={16} className="mt-0.5 text-[#D4AF37]" />
              <a href="https://wa.me/27836274861" className="hover:text-[#D4AF37]">+27 83 627 4861</a>
            </li>
          </ul>
          <Link
            to="/eisg"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#F58220] hover:text-[#D4AF37]"
          >
            {t("footer.visitEisg")} <ArrowUpRight size={14} />
          </Link>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-white/50">
          <div>© {new Date().getFullYear()} BridgeDatum. {t("footer.rights")}</div>
          <div className="tracking-[0.2em] uppercase">{t("footer.tagline")}</div>
        </div>
      </div>
    </footer>
  );
};

export default BDFooter;
